import React from "react";
import { SmartTable } from "../../../core/SmartTable";
import { Icon } from "../../../core/Icon";
import { AppConfig } from "../../../app-state";
import { AppLoad } from "../../../core/AppLoad";
import classNames from "classnames";
import { phpBool } from "../../../core/Helpers";
import moment from "moment";
import { Link } from "react-router-dom";
export const EventAttendees = (props) => {
    var _a;
    const headings = [
        { title: "Účast č." },
        { title: "Celé jméno/Firma" },
        { title: "Email" },
        { title: "Telefon" },
        { title: "Složení jistoty" },
        { title: "Doručení smlouvy" },
        // { title: "Předkupní právo" },
        { title: "Potvrdit účast" },
    ];
    const updateAttendees = (enId, action) => {
        // setLoadState('loadingEdit');
        let now = Math.round(Date.now() / 1000);
        var newAtt = [...props.attendees];
        var attObj = newAtt.filter(o => o.eid == enId)[0];
        let value;
        switch (action) {
            case 'assurance':
                value = !phpBool(attObj.assurance);
                attObj.assurance = !phpBool(attObj.assurance);
                break;
            case 'affidavit':
                value = !phpBool(attObj.affidavit);
                attObj.affidavit = !phpBool(attObj.affidavit);
                break;
            case 'preemptive':
                value = !phpBool(attObj.preemptive);
                attObj.preemptive = !phpBool(attObj.preemptive);
                break;
            case 'confirmed':
                value = now;
                attObj.confirmed = now;
                break;
        }
        props.setAttendees(newAtt);
        AppLoad(AppConfig.APIUrl + 'admin/event-management/update-enrollment', { enId: enId, action: action, value: value }).then((Response) => {
            if (Response.status == 'error') {
                alert(Response.message);
            }
            else if (Response.status == 'ok') {
                console.log("updated");
            }
        });
    };
    const enIdWithPreemptive = props.attendees && ((_a = props.attendees.filter(o => phpBool(o.preemptive))[0]) === null || _a === void 0 ? void 0 : _a.eid);
    if (props.attendees && props.attendees.length == 0)
        return React.createElement("div", { className: "well" }, "Na tomto m\u00EDst\u011B se budou zobrazovat \u00FA\u010Dastn\u00EDci zapsan\u00ED k aukci.");
    return (React.createElement("div", { className: "emf-attendees" },
        React.createElement("h2", { className: "h4" }, "\u00DA\u010Dastn\u00EDci"),
        React.createElement(SmartTable, { headings: headings, rows: props.attendees, row: (o) => {
                return React.createElement("tr", { key: o.eid },
                    React.createElement("td", null, o.eid),
                    React.createElement("td", null,
                        React.createElement(Link, { className: "hyperlink", to: "/cs/sekce/profil/" + o.uid }, o.fullname ? o.fullname : o.company)),
                    React.createElement("td", null, o.email),
                    React.createElement("td", null, o.phone),
                    React.createElement("td", null,
                        React.createElement("button", { className: classNames("confirm-button", { "pressed": phpBool(o.assurance) }), onClick: () => updateAttendees(o.eid, 'assurance') }, phpBool(o.assurance) ? 'Potvrzeno' : 'Potvrdit')),
                    React.createElement("td", null,
                        React.createElement("button", { className: classNames("confirm-button", { "pressed": phpBool(o.affidavit) }), onClick: () => updateAttendees(o.eid, 'affidavit') }, phpBool(o.affidavit) ? 'Potvrzeno' : 'Potvrdit')),
                    React.createElement("td", null, o.confirmed ?
                        React.createElement("div", null,
                            "Odesl\u00E1no ",
                            moment.unix(o.confirmed).format('D. M. YYYY'))
                        :
                            React.createElement("button", { className: "announce-button", onClick: () => updateAttendees(o.eid, 'confirmed') },
                                React.createElement(Icon, { c: ['mail', 12, 12] }),
                                "Zaslat ozn\u00E1men\u00ED")));
            } })));
};
